import { create } from "zustand";
import { SubscriptionApi } from "../../../../apis/subscription";
const useSubscriptionStore = create((set)=>({
        plan: "",
        isExpired: false,
        canCreateInvoice: true,
        isCompanyDetailsCompleted: false,
        duration: "",
        email: "",
        daysLeft: "",
        invoicesRemaining: 0,
        displayFreeTrialMessage: true,
        showPlanExpiredMessage: true,
        displayCanCreateInvoiceMessage: true,
        setDisplayFreeTrialMessage: (value)=>set({
                displayFreeTrialMessage: value
            }),
        setDisplayCanCreateInvoiceMessage: (value)=>set({
                displayCanCreateInvoiceMessage: value
            }),
        setShowPlanExpiredMessage: (value)=>set({
                showPlanExpiredMessage: value
            }),
        setIsCompanyDetailsCompleted: (value)=>set({
                isCompanyDetailsCompleted: value
            }),
        setSubscriptionInfo: (info)=>set(info),
        fetchSubscriptionInfo: async ()=>{
            try {
                const response = await SubscriptionApi.getSubscriptionDetails();
                const { plan, isExpired, duration, email, daysLeft, canCreateInvoice, invoicesRemaining, isCompanyDetailsCompleted } = response.data;
                set({
                    plan,
                    isExpired,
                    duration,
                    email,
                    daysLeft,
                    canCreateInvoice,
                    invoicesRemaining,
                    isCompanyDetailsCompleted
                });
            } catch (error) {
                console.error("Error fetching subscription info:", error);
            }
        }
    }));
export default useSubscriptionStore;
